import axiosInstance from "./axiosInstance";

export const manejarReserva = async (data) => {
    return await axiosInstance.post(
        `${process.env.REACT_APP_BASE_URL}/manejar-reservacion`,
        data
    );
}